import React from "react";
import { FormattedMessage } from "react-intl";

const AzureADConsentSubtitle = () => {
  return (
    <div>
      <FormattedMessage
        id="new-managed-tenant-wizard.consent.subtitle"
        // tslint:disable-next-line: max-line-length
        defaultMessage="To access a tenant, admin consent must be granted to the application. To do this, click the Sign In button below. You will be redirected to the Microsoft sign-in page. Log in as a Global Administrator for the tenant to grant admin consent."
      />
      &nbsp;
      <a
        target="_blank"
        href="https://docs.microsoft.com/en-us/azure/active-directory/develop/application-consent-experience"
        rel="noopener noreferrer"
      >
        <FormattedMessage
          id="new-managed-tenant-wizard.consent.learn-more"
          // tslint:disable-next-line: max-line-length
          defaultMessage="Learn more about admin consent."
        />
      </a>
    </div>
  );
};

export default AzureADConsentSubtitle;
